import React from "react";
import styles from "./Objectives.module.css";
import { Col, Container, Row } from "react-bootstrap";
import { Heading, Paragraph } from "../TextComponents/TextComponents";

const Objectives = () => {
  return (
    <React.Fragment>
      <Container>
        <Heading>Objectives</Heading>
        <Paragraph>
          The project was designed to address key challenges in Gujarat’s energy{" "}
          <br /> landscape, including:
        </Paragraph>
        <div className={styles.Objectives}>
          <Row>
            <Col md={4} sm={12}>
              <div className={styles.section}>
                <img src="/images/project/details/wind.png" alt="wind energy" />
                <p>Contributing to India's national carbon reduction targets</p>
              </div>
            </Col>
            <Col md={4} sm={12}>
              <div className={styles.section}>
                <img src="/images/project/details/machine.png" alt="machine" />
                <p>Decreasing energy costs for government operations.</p>
              </div>
            </Col>
            <Col md={4} sm={12}>
              <div className={styles.section}>
                <img src="/images/project/details/buildings.png" alt="buildings" />
                <p>Enhancing the state’s commitment to renewable energy goals.</p>
              </div>
            </Col>
          </Row>
        </div>
      </Container>
    </React.Fragment>
  );
};

export default Objectives;
